import React from 'react'
import useSelector from 'hooks/use-selector'
import getCurrentIdProductSelect from 'modules/product/redux/selectors/get-current-id'
import useDispatch from 'hooks/use-dispatch'
import getCurrentIdVariantSelect from 'modules/variant/redux/selectors/get-current-id'
import addQuickShopHistoryItemProductAction from 'containers/QuickShopProductSidebar/HandleHistory/actions/add-quick-shop-history-item'

export default function QuickShopProductSidebarHandleHistory () {
  const dispatch = useDispatch()
  const productId = useSelector(getCurrentIdProductSelect)
  const variantId = useSelector(getCurrentIdVariantSelect)

  React.useEffect(() => {
    dispatch(addQuickShopHistoryItemProductAction())
  }, [
    productId,
    variantId
  ])

  return <></>
}
